import { INPUT_FIELD_TYPES } from '../../../constants';
import { flattenSubmission } from '../../../field-preview';
function isRadioGroup(submission) {
  const {
    fieldType,
    label,
    value
  } = flattenSubmission(submission);
  return fieldType === INPUT_FIELD_TYPES.RADIO_GROUP && typeof label === 'string' && typeof value === 'string';
}
function _formatRadioGroup(_ref) {
  let {
    field,
    value
  } = _ref;
  if (!value) {
    return;
  }
  return {
    label: field.view.label,
    value
  };
}
export function formatRadioGroup(submission) {
  if (isRadioGroup(submission)) {
    return _formatRadioGroup(submission);
  }
  return undefined;
}
//# sourceMappingURL=radio-group-preview.js.map